import React from 'react';
import { compose, pick } from 'js/utils/ramda.util';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { Table, TABLE_VIEW } from 'js/components/common/Table';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import * as helpers from './helpers';
import * as actions from './store/actions';
import { SPORTSBOOK_GAMING_HISTORY } from './constants';
import { withDynamicReducer, useDynamicReducerSelector, useDynamicReducerDispatch } from './store';

import * as style from './SportsbookGamingHistory.scss';

export const SportsbookGamingHistoryBare = () => {
    const dispatch = useDynamicReducerDispatch();
    const { isLoading, error, exportError, page: { isPageChanged } } = useDynamicReducerSelector(pick([
        'isLoading', 'error', 'exportError', 'page'
    ]));
    const translate = useComponentTranslations();
    const tableData = hooks.useTableData();
    const loadMore = hooks.useLoadMore();
    const emptyTitle = translate('table.empty');
    const {
        filters,
        headerValidate,
        headerInitialValues,
        anotherPeriodFilter,
        onAnotherPeriodApply,
        afterFiltersControls
    } = hooks.useTableHeader();

    useEffectOnce(() => {
        dispatch(actions.setPeriod(helpers.getInitialPeriodData()));
    }, [dispatch]);

    hooks.useFetchComponent();

    return (
        <Table
            filters={filters}
            classNames={style}
            loadMore={loadMore}
            tableData={tableData}
            emptyTitle={emptyTitle}
            error={error || exportError}
            isDataDesktopAccordion={true}
            headerValidate={headerValidate}
            tableRowView={TABLE_VIEW.ACCORDION}
            isLoading={isLoading && !isPageChanged}
            headerInitialValues={headerInitialValues}
            anotherPeriodFilter={anotherPeriodFilter}
            afterFiltersControls={afterFiltersControls}
            onAnotherPeriodApply={onAnotherPeriodApply}
        />
    );
};

export const SportsbookGamingHistory = compose(
    withComponent({ isForLoggedIn: true }),
    withDynamicReducer()
)(SportsbookGamingHistoryBare);

componentService.registerPageComponents({ [SPORTSBOOK_GAMING_HISTORY]: SportsbookGamingHistory });
